// extracted by mini-css-extract-plugin
export default {"w-full":"Card_w-full__w6EHs","card":"Card_card__ZeevV","head":"Card_head__XGCWI","title":"Card_title__BUrVm","textHelper":"Card_textHelper__LhBbE"};